export const checkResetInput = (
  err = '',
  pinCode: string,
  setPinCode: React.Dispatch<React.SetStateAction<string>>,
) => {
  if (err && pinCode) {
    setPinCode('');
  }
};
